import BaseAvailabilityTag from './BaseAvailabilityTag';

export class Lottery extends BaseAvailabilityTag { }
Lottery.defaultProps = {
    availabilityStatus: "Lottery",
    availabilityClass: "sarsa-availability-tag--lottery",
    isImageOverlay: true
};

export class PartiallyAvailable extends BaseAvailabilityTag { }
PartiallyAvailable.defaultProps = {
    availabilityStatus: "Partially Available",
    availabilityClass: "sarsa-availability-tag--available",
    isImageOverlay: true
};

export class Available extends BaseAvailabilityTag { }
Available.defaultProps = {
    availabilityStatus: "Available",
    availabilityClass: "sarsa-availability-tag--available",
    isImageOverlay: true
};

export class NotReservable extends BaseAvailabilityTag { }
NotReservable.defaultProps = {
    availabilityStatus: "First-come, First-served",
    availabilityClass: "sarsa-availability-tag--firstcome",
    isImageOverlay: true
};

export class Unavailable extends BaseAvailabilityTag { }
Unavailable.defaultProps = {
    availabilityStatus: "Unavailable",
    availabilityClass: "sarsa-availability-tag--unavailable",
    isImageOverlay: true
};

export class New extends BaseAvailabilityTag { }
New.defaultProps = {
    availabilityStatus: "New",
    availabilityClass: "sarsa-availability-tag--new",
    isImageOverlay: true
};

export class EnterDates extends BaseAvailabilityTag { }
EnterDates.defaultProps = {
    availabilityStatus: "Enter Dates",
    availabilityClass: "sarsa-availability-tag--enter-dates",
    isImageOverlay: true
};

export class EnterDate extends BaseAvailabilityTag { }
EnterDate.defaultProps = {
    availabilityStatus: "Enter Date",
    availabilityClass: "sarsa-availability-tag--enter-date",
    isImageOverlay: true
};